import { useRecoilValue } from 'recoil';

import { cn, iaRa, pm } from 'lib/helpers/utility';
import useHasScrollbar from 'lib/hooks/useHasScrollbar';

import { permissions as permissionsState } from 'components/state';

import Item from './Item';

const List = ({ items = [], activeItem, onChange }) => {
  const [ref, hasScrollbar] = useHasScrollbar();

  const permissions = useRecoilValue(permissionsState);

  const checkPerm = (p) => !p || pm(permissions, p);

  return (
    <div className={cn('w-full overflow-hidden p-3', hasScrollbar && 'pr-0')}>
      <div ref={ref} className="flex h-full flex-col overflow-y-auto overflow-x-hidden">
        {items.map((group) => {
          if (!checkPerm(group?.permission)) return;

          const visibleItems = iaRa(group.items).filter(
            (child) => child?.key && !child.hidden && checkPerm(child?.permission)
          );

          if (visibleItems.length === 0) return null;

          return (
            <div key={group.title} className="my-3 flex flex-col gap-[4px] ">
              <span className="flex pb-1 text-xs uppercase leading-[14px] text-neutral-600">
                {group.title}
              </span>

              {visibleItems.map((child) => {
                const isActive = child.key === activeItem?.key;

                return (
                  <Item
                    key={child.key}
                    item={child}
                    isActive={isActive}
                    onClick={() => onChange?.(child)}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
